import React from 'react';

const TagIcon = ({ color = '#757575', width = 20, height = 20, ...rest }, ref) => {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}>
      <path
        d="M9.99984 18.3346H12.4998C15.7215 18.3346 18.3332 15.723 18.3332 12.5013V10.0013C18.3332 6.07293 18.3332 4.10875 17.1128 2.88836C15.8924 1.66797 13.9282 1.66797 9.99984 1.66797C6.07147 1.66797 4.10728 1.66797 2.88689 2.88836C1.6665 4.10875 1.6665 6.07293 1.6665 10.0013C1.6665 13.9297 1.6665 15.8939 2.88689 17.1142C4.10728 18.3346 6.07147 18.3346 9.99984 18.3346Z"
        stroke={color}
        strokeWidth="1.25"
      />
      <path
        d="M12.5 18.3333C12.5 16.7823 12.5 16.0067 12.7039 15.3791C13.1161 14.1106 14.1106 13.1161 15.3791 12.7039C16.0067 12.5 16.7823 12.5 18.3333 12.5"
        stroke={color}
        strokeWidth="1.25"
      />
    </svg>
  );
};

export default React.forwardRef(TagIcon);
